export default "__VITE_ASSET__BrLxQCjT__"